import * as jsxRuntime from "D:\\SMPL\\ecom_clothing\\aura_girl\\client\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment